import {
  attachValidation,
  EditableAccessRule,
  PersistedAccessRule,
  ValidationError,
} from "../../models";

export interface MaxDaysAccessRule extends PersistedAccessRule {
  numberOfDays: number;
  sharedUsage: boolean;
}

export interface EditableMaxDaysAccessRule extends EditableAccessRule {
  numberOfDays: number | null;
  sharedUsage: boolean;
}

export const maxDaysDiffAdapter = {
  isDeleted: (rule: EditableMaxDaysAccessRule) =>
    rule.isNew === false && rule.numberOfDays == null,

  isUpdated: (
    original: MaxDaysAccessRule,
    current: EditableMaxDaysAccessRule,
  ) =>
    original.numberOfDays !== current.numberOfDays ||
    original.sharedUsage !== current.sharedUsage,
};

export const toEditableMaxDays = (
  rule: MaxDaysAccessRule,
): EditableMaxDaysAccessRule =>
  attachValidation(
    {
      ...rule,
      localRuleId: crypto.randomUUID(),
      isNew: false,
      liftAccessRuleId: rule.liftAccessRuleId,
      numberOfDays: rule.numberOfDays,
      sharedUsage: rule.sharedUsage,
    },
    validate,
  );

export const createEmptyEditableMaxDaysRule = (): EditableMaxDaysAccessRule =>
  attachValidation(
    {
      localRuleId: crypto.randomUUID(),
      isNew: true,
      liftAccessRuleId: null,
      numberOfDays: null,
      sharedUsage: false,
    },
    validate,
  );

export function isValidMaxDays(rule: EditableMaxDaysAccessRule): boolean {
  return rule.numberOfDays != null && rule.numberOfDays > 0;
}

export function validate(rule: EditableMaxDaysAccessRule): ValidationError[] {
  const errors: ValidationError[] = [];

  if (rule.numberOfDays == null) {
    errors.push({
      messageKey: "ACCESS_RULE_VALIDATION_MAX_DAYS_REQUIRED",
    });
  } else if (rule.numberOfDays <= 0) {
    errors.push({
      messageKey: "ACCESS_RULE_VALIDATION_MAX_DAYS_MIN",
    });
  }

  return errors;
}
